import { MasterInstance, ScmInstance } from "@/instance/axios";
import { VehiclesGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export type VehicleOption = {
  value: string;
  label: string;
  // group: string;
};

const getAutoCompleteKeyword = () =>
  ScmInstance.vehiclesFindPost().then(
    (res: AxiosResponse<VehiclesGet200ResponseRowsInner[]>) => res.data,
  );

export const useVehiclesAutoComplete = (
  focus = false,
  keyword = "",
  options?: {
    onSuccess: (data: VehicleOption[]) => void;
  },
) => {
  return useQuery(["vehicles-get-autocomplete"], () => getAutoCompleteKeyword(), {
    enabled: focus,
    select: (data: VehiclesGet200ResponseRowsInner[]) =>
      data?.map((vehicle) => {
        return {
          value: String(vehicle.code),
          label: `${String(vehicle.name)}, 차량번호: ${String(vehicle.plateNumber)}`,
          group: String(vehicle.plateNumber),
        };
      }) ?? [],
    onSuccess: options?.onSuccess,
  });
};

const getVehiclesByCode = (code: string | null) =>
  MasterInstance.partnersFindPost({
    ...(code && { search: code }),
    searchFields: ["code"],
  }).then((res: AxiosResponse<VehiclesGet200ResponseRowsInner[]>) => res.data);

export const useVehiclesCode = (
  enabled: boolean,
  code: string | null,
  options?: {
    onSuccess: (data?: VehicleOption[]) => void;
  },
) => {
  return useQuery(["vehicles-get-code", code], () => getVehiclesByCode(code), {
    enabled: enabled ?? false,
    select: (data: VehiclesGet200ResponseRowsInner[]) =>
      data?.map((vehicle) => {
        return {
          value: String(vehicle.code),
          label: String(vehicle.name),
          group: String(vehicle.plateNumber),
        };
      }),
    onSuccess: options?.onSuccess,
  });
};
